var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fromType !== 'case')?_c('div',[(_vm.curPath !== '/gradeHomePage')?_c('img',{staticClass:"icon-back",attrs:{"src":require("@/assets/images/common/ic_back.png"),"alt":""},on:{"click":_vm.handleReturn}}):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289686b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/grade/components/returnBack.vue
// module id = null
// module chunks = 